import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';

function useTranslationOnline(keyPrefix?: string): TFunction {
  const { t } = useTranslation(Domain.ONLINE, { keyPrefix });
  return t;
}

export default useTranslationOnline;
